import {i18n} from 'src/shared/config'

export const translations = {
  title: i18n(
    'banner.title.payment-contract',
    'Оплата с расчётного счёта доступна только в личном кабинете для бизнеса',
  ),
  description: i18n('banner.description.payment-contract', {
    fallBackToKey: false,
  }),
  list: i18n('banner.list.payment-contract', {fallBackToKey: false}),
  imageSrc: i18n('banner.image-src.payment-contract', {fallBackToKey: false}),
}
